import React, { useState } from "react";
import { HiCheckCircle, HiXCircle, HiChevronDown } from 'react-icons/hi';

const BathroomCleaningInfo = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        { 
            question: "Is this service applicable for all types of bathrooms?", 
            answer: "Yes, our methods are effective for marble, ceramic tiles, granite, and porcelain surfaces. We adjust our cleaning agents to suit the specific material of your bathroom." 
        },
        { 
            question: "Will this service damage my expensive bathroom fittings?", 
            answer: "Never. We use specialized non-abrasive cleaners and soft microfiber tools that preserve the finish of your chrome, brass, or matte black fixtures." 
        },
        { 
            question: "What if there is no water or electricity?", 
            answer: "For deep scrubbing and vacuuming, a stable supply is required. If unavailable, we can assist in rescheduling to a time that suits you best." 
        }
    ];

    const included = [
        "Wall & Floor Scrubbing - Deep stain and limescale removal",
        "Disinfection - All sanitary fixtures and touchpoints",
        "Mirror & Glass - Crystal clear, streak-free polish",
        "High-Dusting - Exhaust fans, vents, and light fixtures",
        "Floor Sterilization - Post-scrub sanitizing wash"
    ];

    const excluded = [
        "Inaccessible mold behind wall cavities or structural gaps",
        "Polishing of tarnished metal that requires electroplating",
        "Plumbing repairs or structural maintenance"
    ];

    return (
        <div className="space-y-12">
            {/* Included / Excluded Grid */}
            <div className="grid md:grid-cols-2 gap-8">
                <div className="card-premium p-8 border-l-4 border-l-primary">
                    <h3 className="text-xl font-black text-foreground mb-6 uppercase tracking-widest text-sm text-primary">Service Coverage</h3>
                    <ul className="space-y-4">
                        {included.map((item, i) => (
                            <li key={i} className="flex gap-4 text-sm text-muted-foreground leading-relaxed">
                                <HiCheckCircle className="text-primary shrink-0" size={20} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="card-premium p-8 border-l-4 border-l-destructive/30">
                    <h3 className="text-xl font-black text-foreground mb-6 uppercase tracking-widest text-sm">Policy Notes</h3>
                    <ul className="space-y-4">
                        {excluded.map((item, i) => (
                            <li key={i} className="flex gap-4 text-sm text-muted-foreground leading-relaxed">
                                <HiXCircle className="text-destructive opacity-50 shrink-0" size={20} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Premium FAQ Section */}
            <div className="space-y-6">
                <h3 className="text-2xl font-black text-foreground">Client FAQs</h3>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div 
                            key={index}
                            className="group rounded-2xl border border-border bg-white overflow-hidden transition-all hover:border-primary/30"
                        >
                            <button 
                                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                                className="w-full px-8 py-6 flex items-center justify-between text-left"
                            >
                                <span className="font-bold text-foreground group-hover:text-primary transition-colors">{faq.question}</span>
                                <HiChevronDown 
                                    className={`text-muted-foreground transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`} 
                                    size={20} 
                                />
                            </button>
                            <div 
                                className={`px-8 transition-all duration-300 ease-in-out ${activeIndex === index ? 'pb-8 max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}
                            >
                                <p className="text-sm text-muted-foreground leading-relaxed">
                                    {faq.answer}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BathroomCleaningInfo;
